exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_badge__2RzQW {\n  background-color: var(--navbar-cart-badge-bg-color) !important;\n  /* color: var(--navbar-cart-badge-color); */\n}\n\n.styles_fullContainer__21rGN {\n  position: relative;\n  /* display: flex; */\n  /* flex-direction: column; */\n  overflow-y: auto;\n  height: 100%;\n  margin: 0 auto;\n  padding: 0 var(--page-padding-horizontal);\n  /* margin: 0 var(--page-padding-horizontal); */\n  /* box-shadow: var(--f7-card-box-shadow); */\n}", ""]);

// Exports
exports.locals = {
	"badge": "styles_badge__2RzQW",
	"fullContainer": "styles_fullContainer__21rGN"
};